import { CombinedGraphQLErrors } from '@apollo/client/errors';

/** The `extensions.code` Keystone stamps on a typed refusal, or null. */
export function errorCodeOf(cause: unknown): string | null {
  let current: unknown = cause;
  while (current) {
    if (CombinedGraphQLErrors.is(current)) {
      const code = current.errors.find((error) => error.extensions?.code)?.extensions?.code;
      return typeof code === 'string' ? code : null;
    }
    current = current instanceof Error ? current.cause : null;
  }
  return null;
}

export function isPermissionDenied(cause: unknown): boolean {
  return errorCodeOf(cause) === 'PERMISSION_DENIED';
}

const FRIENDLY: Record<string, string> = {
  PERMISSION_DENIED:
    "You don't have permission to make this change. Your access may have changed — reload the page to check.",
  DUPLICATE_KEY: 'That reference is already taken. Choose a different one.',
  NOT_FOUND:
    'This no longer exists. Someone may have deleted it — reload the page to see the latest.',
  FILE_NOT_VALIDATED: "The file didn't finish uploading. Try uploading it again.",
  FILE_NOT_UPLOADED: "The file didn't reach storage. Try uploading it again.",
  FILE_TOO_LARGE: 'That file is too large to upload.',
  SELF_ACCESS_CHANGE: "You can't change your own access. Ask another admin.",
  LAST_ADMIN: 'This is the last admin. Make someone else an admin first.',
  FILE_METADATA_MISMATCH: 'The file changed while it was uploading. Try uploading it again.',
};

/** A sentence a non-engineer can act on; Keystone's own words for a validation refusal. */
export function friendlyError(cause: unknown): string {
  const code = errorCodeOf(cause);
  if (code && FRIENDLY[code]) {
    return FRIENDLY[code];
  }
  const message = cause instanceof Error ? cause.message : String(cause);
  return message || 'Something went wrong. Try again.';
}
